import { RequiredTranslationsTemplate } from '.'

const sv: RequiredTranslationsTemplate = {
  meta: {
    localeName: 'Swedish',
  },
  home: {
    title: 'ÅTERKALLELSE - ROCKRIDER XC500S',
    description:
      'Tack för att du har köpt en ROCKRIDER XC500S mountainbike (MTB). Vi har identifierat en potentiell svaghet i framgaffeln. Endast vissa cyklar är defekta. Ange de 30 siffrorna i ditt Bike Traceability-nummer för att bekräfta om din cykel berörs av detta återkallande:',
    form: {
      title: 'Ange följande information: ',
      fields: {
        serialNumber: 'N° série (fin)',
        serialNumberFamily: 'N° série (début)',
        firstName: 'Förnamn',
        lastName: 'Efternamn',
        email: 'Email',
        phone: 'Telefon',
        country: 'Land',
        submit: 'Att validera',
        choose: 'Välj...',
      },
      errors: {
        requiredField: 'Detta fält är obligatoriskt',
        unknownSerialNumber: 'Okänt serienummer',
        provide6Numbers: 'Observera att det krävs 6 siffror.',
      },
      confirmations: {
        good: {
          title: 'Din cykel påverkas inte',
          p1: 'Din cykel berörs inte av detta återkallande. Fortsätt att njuta av att cykla på din cykel.',
          p2: 'Vi ber om ursäkt för eventuella besvär,',
          p3: 'Med vänliga hälsningar,',
          p4: 'DECATHLON',
        },
        defective: {
          title: 'Din cykel är tyvärr drabbad',
          p1: 'Vi ber dig att omedelbart sluta använda cykeln och kontakta närmaste Decathlon-butik för att byta ut gaffeln.',
          p2: 'Observera att du kanske inte kan använda din cykel under flera dagar under reparationen. Du kan vara säker på att vi kommer att göra vårt yttersta för att minimera dessa förseningar. Vi rekommenderar att du kontaktar verkstaden i din valda Decathlon-butik direkt för att få en uppskattning av reparationstiden.',
          p3: 'Hitta närmaste Decathlon-verkstad i din närhet:',
          decathlonLocatorLink: 'https://www.decathlon.se/butiker',
          p4: 'Nedan hittar du ditt reparationsintyg som du ska visa upp för vår tekniker när du anländer till verkstaden:',
          p5: 'För mer information, vänligen kontakta vår kundtjänst på telefon Måndag - Torsdag 10:00-17:00 och Fredagar 10:00-16:00. eller via mail på kundservice_online@decathlon.com.',
        },
      },
    },
    findTheSerialNumber: {
      title: 'Hur du hittar ditt spårningsnummer på cykeln:',
      description:
        'Det 30-siffriga numret är tryckt på undersidan av cykelramen, nära bottenstället och pedalerna. Se bilden nedan.',
    },
  },
}

export default sv
